import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import TextField from "@mui/material/TextField";
import { Button, MenuItem, styled } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import NowDataMap from "../../../NowDataMap";
import DeclareContext from "../../../../ContextServer/DeclareContext";
import DataContext from "../../../../ContextServer/DataContext";

// 텍스트 필드, 메뉴아이템 커스터마이징
const CustomTextField = styled(TextField)`
  && {
    & .MuiInputBase-root {
      border: 1px solid #ddd;
      color: #f4f5f5;
      background-color: #fa8526;
      text-align: left;
      height: 47.78px;
    }

    & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #f4f5f5;
    }

    & .MuiSelect-icon {
      color: #f4f5f5;
    }
  }
`;
const CustomMenuItem = styled(MenuItem)`
  && {
    background-color: #fa8526 !important;
    color: #f4f5f5;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    &:hover {
      background-color: #fa5726 !important;
    }

    & .MuiListItemIcon-root {
      min-width: 32px;
    }
  }
`;
const theme = createTheme({
  components: {
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: "#fa8526",
        },
      },
    },
  },
});

const Declare = () => {
  const {
    name,
    setName,
    setAddress,
    phoneNm,
    setPhoneNm,
    dateTime,
    setDateTime,
    odorIntensity,
    setOdorIntensity,
    odorType,
    setOdorType,
    additionalNotes,
    setAdditionalNotes,
    handleSubmit,
    setXcoord,
    setYcoord,
    pwd,
    setPwd,
    pwdCheck,
    setPwdCheck,
  } = useContext(DeclareContext);
  const { setPositionXY, addr, positionXY } = useContext(DataContext);

  useEffect(() => {
    setAddress(addr);
    setXcoord(positionXY && positionXY[0]);
    setYcoord(positionXY && positionXY[1]);
  }, [addr, setAddress]);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const navigate = useNavigate();

  // 경고 메세지
  const [warning, setWarning] = useState("");

  const handleList = () => {
    navigate("/odor/declarelist");
  };

  const setPosition = (pos) => {
    setPositionXY(pos);
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="declare-container">
        <div className="declare-box">
          <div className="declare-title">
            <div className="title">
              <h2>악취 신고(인증) 상세정보</h2>
            </div>
            <button className="list-button" onClick={handleList}>
              목록
            </button>
          </div>
          <div className="map-container">
            <NowDataMap func={setPosition} />
          </div>

          {warning && <p style={{ color: "red" }}>{warning}</p>}
          <form>
            <label>주소* </label>
            <input
              placeholder="지도에 해당 지점을 클릭해주세요."
              type="text"
              value={addr}
              onChange={(e) => setAddress(addr)}
            />

            <label>작성자 이름* </label>
            <input
              type="text"
              value={name}
              onChange={handleNameChange}
              // placeholder="인증과정 거치면 자동으로 등록되게 해야 함."
            />
            <label>전화번호* </label>
            <input
              placeholder=" - 제외하고 입력 바랍니다."
              type="number"
              inputmode="numeric"
              value={phoneNm}
              onChange={(e) => setPhoneNm(e.target.value)}
              // placeholder="인증과정 거치면 자동으로 등록되게 해야 함."
            />
            <label>악취 발생 일시 (신고일시)* </label>
            <input
              type="datetime-local"
              value={dateTime}
              onChange={(e) => setDateTime(e.target.value)}
            />

            <label>악취 강도* </label>
            <CustomTextField
              select
              value={odorIntensity}
              onChange={(e) => setOdorIntensity(e.target.value)}
              placeholder="선택해주세요"
              fullWidth
            >
              <CustomMenuItem value="none">선택해주세요</CustomMenuItem>
              <CustomMenuItem value="0">(0) 무취</CustomMenuItem>
              <CustomMenuItem value="1">(1) 감지취기</CustomMenuItem>
              <CustomMenuItem value="2">(2) 보통취기</CustomMenuItem>
              <CustomMenuItem value="3">(3) 강한취기</CustomMenuItem>
              <CustomMenuItem value="4">(4) 극심한취기</CustomMenuItem>
              <CustomMenuItem value="5">(5) 참기어려운취기</CustomMenuItem>
            </CustomTextField>
            <div className="oderexplain">
              (0) 무취 - 평상시 후각으로 아무것도 감지하지 못하는 정도
              <br /> (1) 약간느낌 - 무슨 냄새인지 알 수 없으나 약간의 냄새를
              느낄 수 있는 정도
              <br /> (2) 보통냄새 - 무슨 냄새인지 알 수 있는 정도
              <br /> (3) 강한냄새 - 쉽게 감지할 수 있는 정도의 강한 냄새, 병원의
              크레졸 냄새 수준
              <br /> (4) 극심한냄새 - 아주 강한 냄새, 여름철 재래식 화장실냄새
              수준
              <br /> (5) 참기어려운냄새 - 견디기 어려운 강렬한 냄새로써 호흡이
              정지될 것 같은 수준
            </div>

            <label>악취 종류* </label>
            <CustomTextField
              select
              value={odorType}
              onChange={(e) => setOdorType(e.target.value)}
              style={{ marginBottom: 15 }}
              fullWidth
            >
              <CustomMenuItem value="none">선택해주세요</CustomMenuItem>
              <CustomMenuItem value="0">
                가축 분뇨 냄새(닭, 돼지, 소)
              </CustomMenuItem>
              <CustomMenuItem value="1">
                공장 냄새(화학약품, 매캐함)
              </CustomMenuItem>
              <CustomMenuItem value="2">소각 냄새(태우는 냄새)</CustomMenuItem>
              <CustomMenuItem value="3">하수구 냄새</CustomMenuItem>
              <CustomMenuItem value="4">음식조리 냄새</CustomMenuItem>
              <CustomMenuItem value="">기타</CustomMenuItem>
            </CustomTextField>

            <label>추가 내용* </label>
            <textarea
              value={additionalNotes}
              onChange={(e) => setAdditionalNotes(e.target.value)}
            ></textarea>
            <strong className="addexplain">
              ** 주민등록번호, 이메일 등 개인정보는 입력하실 수 없습니다.
            </strong>

            <div className="pwCheck">
              <div className="pwCheckFlex">
                <div
                  style={{
                    width: "30%",
                    height: "10vh",
                    float: "left",
                    textAlign: "left",
                  }}
                >
                  <label>비밀번호* </label>
                  <input
                    type="password"
                    style={{ marginTop: "1vh" }}
                    value={pwd}
                    onChange={(e) => setPwd(e.target.value)}
                  />
                </div>

                <div
                  style={{
                    width: "30%",
                    height: "10vh",
                    float: "left",
                    textAlign: "left",
                    // marginLeft: "4vh",
                  }}
                >
                  <label>비밀번호 확인* </label>
                  <input
                    type="password"
                    style={
                      (pwd === pwdCheck
                        ? { border: "1px solid green" }
                        : { border: "1px solid red" },
                      { marginTop: "1vh" })
                    }
                    value={pwdCheck}
                    onChange={(e) => setPwdCheck(e.target.value)}
                    color={pwd === pwdCheck ? "info" : "error"}
                  />
                </div>
              </div>
              <div
                style={{ float: "left", lineHeight: "10vh", marginLeft: "4vh" }}
              >
                {pwd === pwdCheck ? (
                  <small>*비밀번호가 동일합니다.</small>
                ) : (
                  <small style={{ color: "red" }}>*비밀번호가 다릅니다.</small>
                )}
              </div>
            </div>

            <div className="button-container">
              <Button variant="outlined" color="error" onClick={handleList}>
                취소
              </Button>
              <Button
                variant="contained"
                color="success"
                onClick={() => {
                  if (pwd !== pwdCheck) {
                    alert("비밀번호가 다릅니다. 다시 입력해주세요.");
                  } else {
                    handleSubmit();
                  }
                }}
                sx={{ m: 2 }}
              >
                등록
              </Button>
            </div>
          </form>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Declare;
